/* ================================================================
   RIZOMA Home Slider — cinta horizontal tipo marquee editorial

   Comportamiento (fiel al Figma nodo 1:1194):
   - Desktop: scroll horizontal continuo, loop infinito, velocidad
     lineal constante (look de marquee editorial).
   - Mobile: scroll horizontal nativo para respetar los tamaños
     irregulares del Figma sin deformar las imágenes.
   - Marca como .inactive el slide "6 pasos delante del active"
     para generar el ritmo visual del mockup (opacidad 0.6).

   Espera a que Swiper esté disponible. El script se
   carga con defer desde layout/theme.liquid.
================================================================ */

(function () {
  'use strict';

  function initHomeSlider() {
    var el = document.querySelector('.swiper--home-slider');
    if (!el || typeof Swiper === 'undefined') return;

    var isMobile = window.matchMedia('(max-width: 768px)').matches;

    if (isMobile) {
      markStaticInactive(el);
      return;
    }

    new Swiper(el, {
      slidesPerView: 'auto',
      loop: true,
      freeMode: true,
      speed: 5000,
      allowTouchMove: true,
      direction: 'horizontal',
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      on: {
        init: function () { markInactive(this); },
        slideChange: function () { markInactive(this); },
      },
    });

    function markInactive(swiper) {
      var slides = swiper.slides;
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.remove('inactive');
      }
      var idx = (swiper.activeIndex + 5) % slides.length;
      if (slides[idx]) slides[idx].classList.add('inactive');
    }

    function markStaticInactive(root) {
      var slides = root.querySelectorAll('.swiper-slide');
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.remove('inactive');
      }
      if (slides[5]) slides[5].classList.add('inactive');
    }
  }

  // Ejecuta cuando el DOM esté listo y Swiper cargado.
  // Swiper viene con `defer` — puede no estar al DOMContentLoaded.
  function ready() {
    if (typeof Swiper !== 'undefined') {
      initHomeSlider();
    } else {
      // Reintenta hasta que Swiper cargue (máx 50 intentos = 5s)
      var attempts = 0;
      var timer = setInterval(function () {
        attempts++;
        if (typeof Swiper !== 'undefined') {
          clearInterval(timer);
          initHomeSlider();
        } else if (attempts > 50) {
          clearInterval(timer);
          console.warn('[Rizoma] Swiper no cargó después de 5s');
        }
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
